/* Flora Five · persona-loop fixes (theme 034). Loaded with defer from snippets/ff-loop.liquid.
   Small, independent fixes; each one does nothing when its elements are missing. Cycle 2, 2026-10-26. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  /* 1. Collection cards: "FloralWoodyFresh" -> "Floral · Woody". Keeps the first two families. */
  function fixFamilies(root) {
    $$('.ff-card__family-badge:not([data-ff-fixed]), [class*="family"]:not([data-ff-fixed])', root).forEach(function (el) {
      if (el.children.length) { el.setAttribute('data-ff-fixed', ''); return; }
      var t = (el.textContent || '').trim();
      var parts = t.replace(/([a-z])([A-Z])/g, '$1|$2').split('|').filter(Boolean);
      if (parts.length > 1) el.textContent = parts.slice(0, 2).join(' · ');
      el.setAttribute('data-ff-fixed', '');
    });
  }

  /* 2. Sold-out product page: sticky bar offers the in-stock alternatives instead of a dead "Sold out" button,
        and the alternatives move up, right under the price block, above the restock form. */
  function soldOut() {
    var sa = document.getElementById('ff-sa');
    var bis = document.getElementById('ff-bis');
    if (sa && bis && bis.parentNode && sa.compareDocumentPosition(bis) & Node.DOCUMENT_POSITION_PRECEDING) {
      bis.parentNode.insertBefore(sa, bis);
    }
    var controls = $('.sticky-cart-controls');
    if (!controls || $('.ff-so-cta', controls)) return;
    var target = sa ? '#ff-sa' : (bis ? '#ff-bis' : '');
    if (!target) return;
    var a = document.createElement('a');
    a.className = 'ff-so-cta';
    a.href = target;
    a.textContent = sa ? 'Sold out · See similar in stock' : 'Sold out · Get restock alert';
    a.addEventListener('click', function (e) {
      var el = $(target);
      if (!el) return;
      e.preventDefault();
      if (el.hidden) el.hidden = false;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    controls.appendChild(a);
    // Shorter label on small phones
    if (window.innerWidth < 400 && sa) a.textContent = 'Sold out · See similar';
    // Show it only while the chosen size is sold out (the restock script keeps the old button clickable).
    var btn = document.getElementById('js-sticky-btn');
    function sync() {
      if (!btn) return;
      var lab = (btn.querySelector('.sticky-btn-label') || btn).textContent || '';
      controls.classList.toggle('ff-so-on', btn.disabled || /sold\s*out/i.test(lab));
    }
    if (btn) new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
    sync();
  }

  /* 3. Trio and gift box: until every slot is filled, the Add to Cart buttons say how many scents are still
        to choose (they used to read "Add to cart · ₹799" and then fail with an error). */
  function picker(tries) {
    var box = $('.ff-pickn');
    if (!box || !$('.ff-pickn__slot', box)) {
      if ((tries || 0) < 40) setTimeout(function () { picker((tries || 0) + 1); }, 250);
      return;
    }
    var slots = $$('.ff-pickn__slot', box);
    if (!slots.length) return;
    var n = slots.length;
    var btns = [document.getElementById('js-sticky-btn'), $('.product-form__cart-submit')].filter(Boolean);
    var labels = btns.map(function (b) { return b.querySelector('.sticky-btn-label') || b.querySelector('span') || b; });
    var original = labels.map(function (l) { return l.innerHTML; });
    function update() {
      var filled = $$('.ff-pickn__slot.is-filled', box).length;
      var done = filled >= n;
      document.documentElement.classList.toggle('ff-pick-incomplete', !done);
      labels.forEach(function (l, i) {
        if (done) { if (l.getAttribute('data-ff-pick')) { l.innerHTML = original[i]; l.removeAttribute('data-ff-pick'); } return; }
        l.textContent = filled === 0 ? 'Choose your ' + n + ' scents (0/' + n + ')'
          : 'Choose ' + (n - filled) + ' more scent' + (n - filled > 1 ? 's' : '') + ' (' + filled + '/' + n + ')';
        l.setAttribute('data-ff-pick', '1');
      });
      btns.forEach(function (b) {
        var sep = b.querySelector('.sticky-btn-sep'), pr = b.querySelector('.sticky-btn-price');
        if (sep) sep.style.display = done ? '' : 'none';
        if (pr) pr.style.display = done ? '' : 'none';
      });
    }
    // Tapping Add to cart while slots are empty used to show only a red "Please choose your 3 scents first." under three
    // empty boxes. The picker marks the box invalid at that moment; when it does, open the picker on the next empty slot.
    var wasInvalid = false;
    new MutationObserver(function () {
      var inv = box.classList.contains('ff-pickn--invalid');
      if (inv && !wasInvalid) {
        var next = $('.ff-pickn__slot:not(.is-filled)', box);
        if (next) { next.scrollIntoView({ block: 'center' }); setTimeout(function () { next.click(); }, 80); }
      }
      wasInvalid = inv;
    }).observe(box, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(update).observe(box, { subtree: true, attributes: true, attributeFilter: ['class'] });
    update();
  }

  /* 5. Links to /products/build-a-box (menu feature card, collection banner) went to a 404 page. */
  function fixDeadLinks() {
    $$('a[href^="/products/build-a-box"]').forEach(function (a) { a.setAttribute('href', '/products/build-your-trio-3-ml'); });
    // Empty-cart links that returned 404 (QA, 26 Oct).
    var map = { '/collections/oud': '/collections/ouds', '/collections/gifting': '/products/diwali-gift-box-6-ml', '/collections/gift-sets': '/collections/combo-packs' };
    $$('a[href]').forEach(function (a) { var h = a.getAttribute('href').split('?')[0].replace(/\/$/, ''); if (map[h]) a.setAttribute('href', map[h]); });
    $$('.mini-cart-empty p, .mini-cart-empty .h5, .mini-cart-empty span').forEach(function (el) { if (/^\s*No products in the cart\.?\s*$/i.test(el.textContent)) el.textContent = 'Your cart is empty.'; });
    var names = { 'Mega Saver': '15% off over ₹700', 'B4G2': 'Buy 4 get 2 free', 'B3G1': 'Buy 3 get 1 free', 'BULK2K': '₹2,000 off over ₹6,000', 'Trio Discount': 'Trio 30% off' };
    $$('.cart-item__discount').forEach(function (el) { var t = el.textContent.trim(); if (names[t]) el.textContent = names[t]; });
  }

  /* 6. Product page: one plain delivery line under the price (shoppers asked what delivery costs on a ₹399 order). */
  function deliveryLine(box) {
    var price = $('.product-single__price');
    if (!price || $('.ff-pdp-deliv')) return;
    var host = price.closest('.product-single__prices, .price-container, .product-block') || price.parentNode;
    var p = document.createElement('p');
    p.className = 'ff-pdp-deliv';
    // COD fee stated up front (cycle 4: shoppers found the ₹50 only far down the page).
    p.textContent = box ? 'Free delivery · Cash on Delivery +₹50 · 7-day exchange' : 'Delivery ₹49, free from ₹499 · Cash on Delivery +₹50 · 7-day exchange';
    host.parentNode.insertBefore(p, host.nextSibling);
    // Delivery time, from Armaan (26 Oct): 3-4 working days within the zone, about 5 to Delhi and big cities, 6-10 elsewhere.
    var eta = document.createElement('p');
    eta.className = 'ff-pdp-eta';
    eta.textContent = 'Usually delivered in 3–4 working days in and around Punjab, about 5 to Delhi and big cities, 6–10 to farther areas.';
    p.parentNode.insertBefore(eta, p.nextSibling);
    if (box) return;
    // Trust line from approved facts (shoppers asked for proof on the first screen; most scents have no reviews yet).
    var tr = document.createElement('p');
    tr.className = 'ff-pdp-trust';
    // Google rating moved down to the reviews area: next to "12,000+ orders", 11 reviews read as a mismatch (cycle 9).
    tr.textContent = 'Alcohol-free perfume oil · Made in Sirhind · 12,000+ orders since 2022';
    p.parentNode.insertBefore(tr, p);
    // Price per ml next to the price, following the size picker (comparers did the maths by hand).
    var per = document.createElement('span');
    per.className = 'ff-per-ml';
    price.parentNode.insertBefore(per, price.nextSibling);
    function perMl() {
      var r = document.querySelector('.single-option-selector__radio:checked, input[type=radio][name*=ize]:checked');
      var size = r ? parseFloat(r.value) : NaN;
      if (!(size > 0) || !/ml/i.test(r.value)) { var sel = document.getElementById('js-sticky-option-1'); size = sel ? parseFloat(sel.value) : NaN; }
      var amt = parseFloat((price.textContent || '').replace(/[^0-9.]/g, ''));
      per.textContent = size > 0 && amt > 0 ? '₹' + Math.round(amt / size) + ' per ml' : '';
    }
    perMl();
    new MutationObserver(perMl).observe(price, { childList: true, characterData: true, subtree: true });
    document.addEventListener('change', function () { setTimeout(perMl, 50); });
  }

  /* 14. Product page: an option with a single choice ("Style: Regular Bottle") looked like a decision to make. Hide it. */
  function oneOptionRows() {
    $$('.product-button-variant .selector-wrapper').forEach(function (w) {
      if (w.querySelectorAll('input[type=radio], option').length === 1) w.classList.add('ff-one-opt');
    });
  }

  /* 15. Two Add to cart buttons showed at once (page button + sticky bar). Slide the sticky bar away while the page's own button is on screen. */
  function stickyWhenFormHidden() {
    var btn = $('form[action*="/cart/add"] [name=add]');
    var bar = $('.sticky-cart-wr');
    if (!btn || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { document.documentElement.classList.toggle('ff-atc-inview', e.isIntersecting); });
    }, { rootMargin: '0px 0px -60px 0px' }).observe(btn);
  }

  /* 16. Prices showed as ₹1299 in some places and ₹1,299 in others. Add the comma everywhere (4+ digit rupee amounts). */
  var RUPEE = /₹(\s?)(\d{4,})(?![\d,])/g;
  var RS = /Rs\.\s?(?=\d)/g;
  function commaRupees(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) { RUPEE.lastIndex = 0; RS.lastIndex = 0; if (RUPEE.test(n.nodeValue) || RS.test(n.nodeValue)) hits.push(n); }
    hits.forEach(function (t) {
      // "Rs. 1,017.45" (cart page) becomes "₹1,017.45" so it matches the rest of the site.
      t.nodeValue = t.nodeValue.replace(RS, '₹').replace(RUPEE, function (m, sp, d) { return '₹' + sp + Number(d).toLocaleString('en-IN'); });
    });
  }

  /* 17. Fully sold-out product (often an ad landing): put the in-stock alternatives and the restock form on the
        first screen, right under the price, and hide the struck-out size buttons that looked broken. */
  function soldOutTop() {
    var path = location.pathname.replace(/\/$/, '');
    if (!/\/products\//.test(path)) return;
    fetch(path + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      if (!p || p.available) return;
      document.documentElement.classList.add('ff-all-sold');
      var sa = document.getElementById('ff-sa'), bis = document.getElementById('ff-bis');
      var anchor = $('.ff-pdp-deliv') || $('.product-single__meta-price');
      if (!anchor) return;
      var first = sa || bis;
      if (first) anchor.parentNode.insertBefore(first, anchor.nextSibling);
      if (sa && bis) sa.parentNode.insertBefore(bis, sa.nextSibling);
      if (bis) bis.hidden = false;
      // Some ad visitors want this exact scent: offer the restock alert on the first screen too.
      if (sa && bis && !document.querySelector('.ff-bis-jump')) {
        var j = document.createElement('a');
        j.className = 'ff-bis-jump'; j.href = '#ff-bis'; j.textContent = 'Want this one? Get a message when it’s back';
        j.addEventListener('click', function (e) { e.preventDefault(); bis.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        anchor.parentNode.insertBefore(j, sa);
      }
    }).catch(function () {});
  }

  /* 18. Collection and search grids: sold-out cards move to the end of the page so shoppers see what they can buy first. */
  function soldOutLast() {
    $$('ul.product-grid').forEach(function (ul) {
      var items = Array.prototype.filter.call(ul.children, function (li) { return li.matches('li') && li.querySelector('.product-tag--sold-out'); });
      var last = ul.lastElementChild;
      if (!items.length || items.every(function (li, i) { return li === ul.children[ul.children.length - items.length + i]; })) return;
      items.forEach(function (li) { ul.appendChild(li); });
    });
  }

  onReady(function () {
    fixFamilies(document);
    // soldOutTop() retired 26 Oct: the move now happens server-side in snippets/ff-soldout-alternatives.liquid (no layout jump).
    if ($('ul.product-grid')) {
      soldOutLast();
      var gt;
      $$('ul.product-grid').forEach(function (ul) {
        new MutationObserver(function () { clearTimeout(gt); gt = setTimeout(soldOutLast, 200); }).observe(ul, { childList: true });
      });
    }
    commaRupees(document.body);
    var ct;
    new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(function () { commaRupees(document.body); }, 150); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
    fixDeadLinks();
    if ($('.ff-pickn, [data-ff-pickn]') || /build-your-trio|gift-box/.test(location.pathname)) document.documentElement.classList.add('ff-has-pickn');
    if (document.body.classList.contains('template-product')) deliveryLine(/build-your-trio|gift-box|sample-set|attar-trio/.test(location.pathname));
    if (document.body.classList.contains('template-product')) { oneOptionRows(); stickyWhenFormHidden(); }
    if (document.body.classList.contains('template-product')) { soldOut(); picker(); }
    // Cards added later (infinite scroll, recommendations, search drawer)
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { fixFamilies(document); fixDeadLinks(); }, 120); })
      .observe(document.body, { childList: true, subtree: true });
  });
})();

/* 4. Cart drawer: keep the Buy 4 Get 2 line in step with the cart after items are added or removed
      (the drawer's Liquid only knows the cart as it was when the page loaded). */
(function () {
  'use strict';
  function paint(count) {
    var els = document.querySelectorAll('[data-ff-b4g2]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (count >= 6) { el.innerHTML = 'Buy 4 Get 2 applies automatically: <strong>2 bottles free</strong> at checkout.'; el.hidden = false; }
      else if (count >= 4) { var r = 6 - count; el.innerHTML = 'Add ' + r + ' more bottle' + (r > 1 ? 's' : '') + ' and <strong>2 of the 6 are free</strong> (Buy 4 Get 2).'; el.hidden = false; }
      else el.hidden = true;
    }
  }
  var t;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { paint(c.item_count || 0); }).catch(function () {});
    }, 300);
  }
  function start() {
    var total = document.querySelector('.mini-cart-footer .js-cart-total');
    if (total && 'MutationObserver' in window) new MutationObserver(refresh).observe(total, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 7. Trio / gift box picker: scents were listed A to Z ("Aab Attar", "Aagosh Attar" first), so shoppers met obscure names
      first. Order them by how well they sell (the Attars and Ouds collections are sorted by best-selling; the two lists are
      interleaved by position) and mark the top six "Bestseller". */
(function () {
  'use strict';
  var rank = null, busy = false;
  function getList(h) {
    return fetch('/collections/' + h + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; })
      .catch(function () { return []; });
  }
  function loadRank() {
    if (rank) return Promise.resolve(rank);
    return Promise.all([getList('attars'), getList('ouds')]).then(function (ls) {
      var r = {};
      ls.forEach(function (l) {
        var avail = l.filter(function (p) { return (p.variants || []).some(function (v) { return v.available; }); });
        avail.forEach(function (p, i) { var k = (i + 0.5) / avail.length; if (!(p.title in r) || k < r[p.title]) r[p.title] = k; });
      });
      rank = r;
      return r;
    });
  }
  function apply(grid) {
    if (busy || !rank) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ff-pk__card'));
    if (cards.length < 2) return;
    function key(c) { var b = c.querySelector('[data-pick]'); var t = b ? b.getAttribute('data-pick') : ''; return t in rank ? rank[t] : 2; }
    var sorted = cards.slice().sort(function (a, b) { return key(a) - key(b); });
    var top = Object.keys(rank).sort(function (a, b) { return rank[a] - rank[b]; }).slice(0, 3);
    busy = true;
    sorted.forEach(function (c) {
      grid.appendChild(c);
      var b = c.querySelector('[data-pick]'), imgBox = c.querySelector('.ff-pk__img');
      if (b && imgBox && top.indexOf(b.getAttribute('data-pick')) > -1 && !imgBox.querySelector('.ff-pk__tag')) {
        var s = document.createElement('span'); s.className = 'ff-pk__tag ff-pk__tag--best'; s.textContent = 'Bestseller'; imgBox.appendChild(s);
      }
    });
    // First rows load straight away (shoppers on 3G saw grey empty tiles when the sheet opened).
    sorted.slice(0, 12).forEach(function (c) { var im = c.querySelector('img[loading=lazy]'); if (im) im.loading = 'eager'; });
    busy = false;
  }
  function watch(tries) {
    var grid = document.querySelector('.ff-pk__grid');
    if (!grid) { if ((tries || 0) < 40) setTimeout(function () { watch((tries || 0) + 1); }, 300); return; }
    // The observer is paused while cards are re-ordered, so the re-ordering itself never triggers another pass.
    var mo = new MutationObserver(function () { run(); });
    function run() { mo.disconnect(); apply(grid); mo.observe(grid, { childList: true }); }
    loadRank().then(run);
  }
  if (!/build-your-trio|gift-box/.test(location.pathname)) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(0); }); else watch(0);
})();

/* 8. Scent picker: show what is already in the box at the top of the picker sheet ("Your box: Armani Si · 2 to go"),
      because after the first pick the sheet only changed its title and shoppers lost track. */
(function () {
  'use strict';
  if (!/build-your-trio|gift-box/.test(location.pathname)) return;
  function names() {
    return Array.prototype.map.call(document.querySelectorAll('.ff-pickn__slot'), function (s) {
      return s.classList.contains('is-filled') ? (s.querySelector('.ff-pickn__slot-name') || {}).textContent : null;
    });
  }
  function paint() {
    var head = document.querySelector('.ff-pk__count');
    if (!head) return;
    var bar = document.querySelector('.ff-pk__box');
    if (!bar) { bar = document.createElement('p'); bar.className = 'ff-pk__box'; head.parentNode.insertBefore(bar, head); }
    var n = names(), got = n.filter(Boolean), left = n.length - got.length;
    bar.hidden = !got.length;
    bar.textContent = got.length ? 'Your box: ' + got.join(' · ') + (left ? ' · ' + left + ' to go' : ' · complete') : '';
  }
  function start(tries) {
    var box = document.querySelector('.ff-pickn'), grid = document.querySelector('.ff-pk__grid');
    if (!box || !grid) { if ((tries || 0) < 40) setTimeout(function () { start((tries || 0) + 1); }, 300); return; }
    new MutationObserver(paint).observe(box, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    new MutationObserver(paint).observe(grid, { childList: true });
    paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(0); }); else start(0);
})();

/* 9. Cart drawer: name the offer that lowered the subtotal ("₹899 x 1" next to "Subtotal ₹764" read as an error). */
(function () {
  'use strict';
  function rupees(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  var t;
  function paint(c) {
    var bt = document.querySelector('.ff-cart-sum .bottom-total');
    if (!bt) return;
    var el = document.querySelector('.ff-cart-offer');
    if (!el) { el = document.createElement('p'); el.className = 'ff-cart-offer'; bt.parentNode.insertBefore(el, bt); }
    var off = c && c.total_discount ? c.total_discount : 0;
    if (!off) { el.hidden = true; return; }
    var titles = [];
    var plain = { 'Mega Saver': '15% off over ₹700', 'B4G2': 'Buy 4 get 2 free', 'B3G1': 'Buy 3 get 1 free', 'BULK2K': '₹2,000 off over ₹6,000', 'Trio Discount': 'Trio 30% off', 'QUIZBUNDLE6': 'Quiz bundle: 6 for the price of 4' };
    (c.cart_level_discount_applications || []).forEach(function (d) { if (d.title && titles.indexOf(d.title) < 0) titles.push(d.title); });
    (c.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var ti = a.discount_application && a.discount_application.title; if (ti && titles.indexOf(ti) < 0) titles.push(ti); }); });
    el.hidden = false;
    titles = titles.map(function (x) { return plain[x] || x; });
    el.innerHTML = '<span>Offer applied' + (titles.length ? ': ' + titles.join(', ').replace(/[<>&]/g, '') : '') + '</span><span>−' + rupees(off) + '</span>';
  }
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {});
    }, 120);
  }
  function start() {
    var total = document.querySelector('.ff-cart-sum .js-cart-total');
    if (!total) return;
    new MutationObserver(refresh).observe(total, { childList: true, characterData: true, subtree: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 10. Product reviews with none yet: say so plainly and point to the store's real Google rating, instead of an empty box. */
(function () {
  'use strict';
  function run(tries) {
    var w = document.querySelector('.jdgm-rev-widg[data-number-of-reviews="0"]');
    if (!w) { if ((tries || 0) < 30) setTimeout(function () { run((tries || 0) + 1); }, 500); return; }
    if (w.querySelector('.ff-rev-none')) return;
    var p = document.createElement('p');
    p.className = 'ff-rev-none';
    p.innerHTML = 'No reviews for this scent yet. Our Sirhind store is rated 4.3 on Google from 11 reviews. ' +
      '<a href="https://www.google.com/maps/place/?q=place_id:ChIJSZWQqMUfEDkRRakmdOruJuk" target="_blank" rel="noopener">See them on Google</a>';
    var head = w.querySelector('.jdgm-rev-widg__header') || w.firstElementChild;
    if (head) head.appendChild(p); else w.appendChild(p);
  }
  if (!document.body || !document.body.classList.contains('template-product')) { document.addEventListener('DOMContentLoaded', function () { if (document.body.classList.contains('template-product')) run(0); }); return; }
  run(0);
})();

/* 11. Scent quiz, first step: after "Him / Her / Unisex", bring the second question into view so the step is not stuck. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('.ff-quiz__option');
    if (!o) return;
    var group = o.parentElement, next = group && group.nextElementSibling;
    while (next && !next.querySelector('.ff-quiz__option')) next = next.nextElementSibling;
    if (next && !next.querySelector('[aria-pressed="true"]')) setTimeout(function () { next.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
  });
})();

/* 12. Empty cart page: plain words instead of "Your Olfactory Collection Awaits / Curated artisanal oils / aged royal ouds"
       (shoppers called it template copy, and "aged" is not a claim Flora Five makes). */
(function () {
  'use strict';
  function run() {
    var box = document.querySelector('.ff-apple-empty-cart');
    if (!box) return;
    var map = [
      ['.ff-empty-cart-title', 'Your cart is empty'],
      ['.ff-empty-cart-desc', 'Alcohol-free attars and ouds, blended in small batches in Sirhind. Start with a bestseller, or let the scent finder suggest one.']
    ];
    map.forEach(function (m) { var el = box.querySelector(m[0]); if (el) el.textContent = m[1]; });
    var words = { 'Pure Attars': 'Attars', 'Alcohol-free pure oils': 'Alcohol-free perfume oils', 'Royal Ouds': 'Ouds',
      'Deep artisanal woods': 'Deep, woody blends', 'Luxury Gift Sets': 'Gift sets', '3ml & 6ml curated boxes': 'Trio and Diwali gift box',
      'Explore All Fragrances →': 'Shop all fragrances', 'Take Scent Quiz': 'Find your scent' };
    Array.prototype.forEach.call(box.querySelectorAll('.ff-empty-bento-title, .ff-empty-bento-sub, .ff-empty-btn-primary, .ff-empty-btn-secondary'), function (el) {
      var t = el.textContent.trim();
      if (words[t]) { var svg = el.querySelector('svg'); el.textContent = words[t]; if (svg && el.classList.contains('ff-empty-btn-secondary')) el.insertBefore(svg, el.firstChild); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* 13. Cart drawer: list the scents chosen for a trio or gift box under the line (shoppers could not check their picks). */
(function () {
  'use strict';
  var t;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function paint(c) {
    // There are two cart containers (drawer + header dropdown); paint each one on its own.
    Array.prototype.forEach.call(document.querySelectorAll('.js-mini-cart-content'), function (box) { paintBox(box, c); });
  }
  function paintBox(box, c) {
    var rows = box.querySelectorAll('.mini-cart-item');
    if (!c || !c.items || rows.length !== c.items.length) return;
    c.items.forEach(function (it, i) {
      var row = rows[i], meta = row.querySelector('.mini-cart-meta') || row;
      var old = row.querySelector('.ff-line-props'); if (old) old.remove();
      var props = it.properties || {}, keys = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' && props[k] && k !== 'Gift message'; });
      if (!keys.length) return;
      var p = document.createElement('p'); p.className = 'ff-line-props';
      p.innerHTML = keys.map(function (k) { return esc(props[k]); }).join('<br>');
      var title = meta.querySelector('a, .mini-cart-title, h3, h4');
      if (title && title.parentNode === meta) title.after(p); else meta.insertBefore(p, meta.firstChild ? meta.firstChild.nextSibling : null);
    });
  }
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () { fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {}); }, 120);
  }
  function start() {
    var boxes = document.querySelectorAll('.js-mini-cart-content');
    if (!boxes.length) return;
    Array.prototype.forEach.call(boxes, function (box) {
      new MutationObserver(function (m) { if (m.some(function (x) { return x.target === box; })) refresh(); }).observe(box, { childList: true });
    });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 19. Save for later: a heart on product cards and product pages, and a "Saved" list in the header.
       Shoppers comparing scents before payday had no way to keep a shortlist. Stored on this device only. */
(function () {
  'use strict';
  var KEY = 'ff_saved_v1';
  var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" d="M12 20.5s-7.5-4.6-7.5-10A4.5 4.5 0 0 1 12 7.2a4.5 4.5 0 0 1 7.5 3.3c0 5.4-7.5 10-7.5 10z"/></svg>';
  function esc(x) { return String(x || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() { try { var l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function store(l) { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, 40))); } catch (e) {} }
  function handleOf(u) { var m = String(u || '').match(/\/products\/([^\/?#]+)/); return m ? m[1] : ''; }
  function toast(msg) {
    var t = document.querySelector('.ff-save-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ff-save-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  function toggle(item) {
    var l = load(), i = -1;
    l.forEach(function (x, k) { if (x.h === item.h) i = k; });
    if (i > -1) l.splice(i, 1); else l.unshift(item);
    store(l); sync();
    if (item.t) toast(i > -1 ? 'Removed from your saved scents' : 'Saved. Find it under the heart at the top.');
  }
  function sync() {
    var l = load();
    Array.prototype.forEach.call(document.querySelectorAll('[data-ff-save]'), function (b) {
      var on = l.some(function (x) { return x.h === b.getAttribute('data-ff-save'); });
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = b.querySelector('.ff-save__label'); if (lab) lab.textContent = on ? 'Saved' : 'Save for later';
    });
    var c = document.querySelector('.ff-saved-count');
    if (c) { c.textContent = l.length; c.hidden = !l.length; }
  }
  function cardItem(card) {
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return null;
    var nm = card.querySelector('.product-card__name'), im = card.querySelector('img'), pr = card.querySelector('.product-card__price');
    return { h: handleOf(a.getAttribute('href')), t: ((nm && nm.textContent) || a.getAttribute('aria-label') || '').trim().slice(0, 80),
      i: im ? (im.currentSrc || im.src || '') : '', p: pr ? pr.textContent.trim().replace(/\s+/g, ' ').slice(0, 30) : '' };
  }
  function addCardButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-card .product-card__image-wr:not([data-ff-sv])'), function (w) {
      w.setAttribute('data-ff-sv', '');
      var card = w.closest('.product-card'), it = card && cardItem(card);
      if (!it || !it.h) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ff-save ff-save--card';
      b.setAttribute('data-ff-save', it.h); b.setAttribute('aria-label', 'Save ' + it.t + ' for later');
      b.innerHTML = HEART;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(cardItem(card) || it); });
      w.appendChild(b);
    });
  }
  function addPdpButton() {
    if (!document.body.classList.contains('template-product') || document.querySelector('.ff-save--pdp')) return;
    if (/build-your-trio|gift-box/.test(location.pathname)) return;
    var anchor = document.querySelector('.ff-pdp-eta') || document.querySelector('.ff-pdp-deliv') || document.querySelector('.ff-pdp-trust') || document.querySelector('.product-single__meta-price');
    if (!anchor) return;
    var h = handleOf(location.pathname);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ff-save ff-save--pdp'; b.setAttribute('data-ff-save', h);
    b.innerHTML = HEART + '<span class="ff-save__label">Save for later</span>';
    b.addEventListener('click', function () {
      var t = document.querySelector('.product-single__title, h1'), im = document.querySelector('.product-single__photo img, .my-gallery img'), pr = document.querySelector('.product-single__price');
      toggle({ h: h, t: t ? t.textContent.trim().slice(0, 80) : '', i: im ? (im.currentSrc || im.src || '') : '', p: pr ? 'From ' + pr.textContent.trim() : '' });
    });
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
  }
  function panel() {
    var p = document.querySelector('.ff-saved-panel');
    if (!p) {
      p = document.createElement('div'); p.className = 'ff-saved-panel'; p.hidden = true;
      p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true'); p.setAttribute('aria-label', 'Saved scents');
      document.body.appendChild(p);
      p.addEventListener('click', function (e) {
        if (e.target === p || e.target.closest('[data-close]')) { p.hidden = true; return; }
        var r = e.target.closest('[data-remove]');
        if (r) { toggle({ h: r.getAttribute('data-remove') }); render(p); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') p.hidden = true; });
    }
    return p;
  }
  function render(p) {
    var l = load();
    p.innerHTML = '<div class="ff-saved-sheet"><div class="ff-saved-head"><strong>Saved scents</strong><button type="button" data-close aria-label="Close">&times;</button></div>' +
      (l.length ? '<ul>' + l.map(function (x) {
        return '<li><a href="/products/' + encodeURIComponent(x.h) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="ff-saved-noimg"></span>') +
          '<span><b>' + esc(x.t) + '</b><small>' + esc(x.p) + '</small></span></a><button type="button" data-remove="' + esc(x.h) + '">Remove</button></li>';
      }).join('') + '</ul><p class="ff-saved-note">Saved on this device.</p>'
        : '<p class="ff-saved-empty">Tap the heart on any scent to keep it here while you decide. Saved on this device.</p>') + '</div>';
  }
  function header() {
    var cart = document.querySelector('.header-bottom__right .site-header__cart');
    if (!cart || document.querySelector('.ff-saved-btn')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ff-saved-btn'; b.setAttribute('aria-label', 'Saved scents');
    b.innerHTML = HEART + '<span class="ff-saved-count" hidden>0</span>';
    b.addEventListener('click', function () { var p = panel(); render(p); p.hidden = false; var c = p.querySelector('[data-close]'); if (c) c.focus(); });
    cart.parentNode.insertBefore(b, cart);
  }
  function init() {
    header(); addCardButtons(); addPdpButton(); sync();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { addCardButtons(); addPdpButton(); sync(); }, 250); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 20. Product page: say when this scent is already in the cart (quiz shoppers added it twice). */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-product')) return;
  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (!handle) return;
  var t;
  function paint(c) {
    var n = 0, sizes = [];
    (c.items || []).forEach(function (it) {
      if (it.handle !== handle) return;
      n += it.quantity;
      var sz = (it.variant_options || []).filter(function (o) { return /ml/i.test(o); })[0];
      if (sz && sizes.indexOf(sz) < 0) sizes.push(sz);
    });
    var el = document.querySelector('.ff-in-cart');
    var btn = document.querySelector('form[action*="/cart/add"] [name=add]');
    if (!btn) return;
    if (!el) { el = document.createElement('p'); el.className = 'ff-in-cart'; btn.parentNode.insertBefore(el, btn); }
    el.hidden = !n;
    el.innerHTML = n ? 'Already in your cart' + (sizes.length ? ': ' + sizes.join(', ') : '') + ' (' + n + ') · <a href="/cart">View cart</a>' : '';
  }
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {}); }, 200);
  }
  function start() {
    refresh();
    Array.prototype.forEach.call(document.querySelectorAll('.js-mini-cart-content'), function (box) {
      new MutationObserver(refresh).observe(box, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
